import { TokenInterceptor } from './interceptors/token.interceptor';
import { NgModule, Optional, SkipSelf, LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { environment } from '@environment/environment';
import { CustomLoader } from './utils/custom-loader';
import { ErrorsMissingTranslation } from './utils/errors-missing-translation';

const defaultLanguage = 'es';
registerLocaleData(localeEs, defaultLanguage);

function createTranslateLoader(http: HttpClient) {
  return new CustomLoader(http);
}

const COMPONENTS = [];

const MODULES = [
  HttpClientModule,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpClient],
    },
    // missingTranslationHandler: {
    //   provide: MissingTranslationHandler,
    //   useClass: ErrorsMissingTranslation,
    // },
    defaultLanguage,
  }),
];

const PROVIDERS = [
  { provide: LOCALE_ID, useValue: defaultLanguage },
  { provide: 'googleTagManagerId', useValue: environment.gtmId },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  providers: [...PROVIDERS],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
